import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckIcon, KeyRoundIcon, LifeBuoyIcon, MonitorSmartphoneIcon, XIcon } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { SettingsGroup, SettingsRow, SettingsToggleRow } from '../../components/SettingsList';
import { SectionTitle } from '../../components/ui/Card';
import { loginActivity, sessions } from '../../data/settings';
import { useLocale } from '../../contexts/LocaleContext';
import { useSettings } from '../../contexts/SettingsContext';
export function Security() {
  const {
    t,
    tl
  } = useLocale();
  const navigate = useNavigate();
  const settings = useSettings();
  const active = sessions.filter(session => !settings.signedOutSessions.includes(session.id));
  return <div className="px-2 pb-2" data-id="element-3487" data-mp="1iulobyffn4tm">
      <PageHeader title={t('settings.security')} subtitle={t('security.subtitle')} showBack data-id="element-3488" data-mp="1ivwntm1uhqex" />

      <SectionTitle data-id="element-3489" data-mp="1dtxnkl1ej9m7">{t('security.access')}</SectionTitle>
      <SettingsGroup data-id="element-3490" data-mp="2kuqxjjpu2l65">
        <SettingsRow label={t('security.password')} hint={t('security.passwordHint')} icon={<KeyRoundIcon size={17} data-id="element-3492" data-mp="2puwfu9a7qvbk" />} onClick={() => navigate('/config/seguranca')} data-id="element-3491" data-mp="2kva464a19n4v" />
        <SettingsToggleRow label={t('security.twoFactor')} hint={t('security.twoFactorHint')} checked={settings.twoFactor} onChange={settings.setTwoFactor} data-id="element-3493" data-mp="2twi2gmcjunyy" />
        <SettingsRow label={t('security.recovery')} hint={t('security.recoveryHint')} icon={<LifeBuoyIcon size={17} data-id="element-3495" data-mp="3dicxmhzur7o9" />} onClick={() => navigate('/config/ajuda')} data-id="element-3494" data-mp="33qqr2yyglwru" />
      </SettingsGroup>

      <div className="mt-3" data-id="element-3496" data-mp="3hkhpbb6qpu89">
        <SectionTitle data-id="element-3497" data-mp="3hiok80brzi2d">{t('security.devices')}</SectionTitle>
        <SettingsGroup data-id="element-3498" data-mp="3mjb211e7dh7d">
          <SettingsRow label={t('security.sessions')} value={String(active.length)} icon={<MonitorSmartphoneIcon size={17} data-id="element-3500" data-mp="3rinqtromwycl" />} onClick={() => navigate('/config/sessoes')} data-id="element-3499" data-mp="3mk41rieqv6g0" />
          <SettingsRow label={t('security.trusted')} hint={t('security.trustedHint')} value={String(active.filter(session => session.trusted).length)} data-id="element-3501" data-mp="1rg61m5i3tefa" />
        </SettingsGroup>
      </div>

      <section className="mt-3" data-id="element-3502" data-mp="1wf99dxpgxyqy">
        <SectionTitle data-id="element-3503" data-mp="1wdy2hp0q8avm">{t('security.activity')}</SectionTitle>
        <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-3504" data-mp="2a649akhzp5ie">
          {loginActivity.map(event => <li key={event.id} className="flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0" data-id="element-3505" data-mp="265kazdlojvuo">
              <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-pill ${event.ok ? 'bg-sand-deep text-soft' : 'bg-deep text-gold'}`} data-id="element-3506" data-mp="2k27nioq48ulp">
                {event.ok ? <CheckIcon size={14} data-id="element-3507" data-mp="krzetzz1ubye" /> : <XIcon size={14} data-id="element-3508" data-mp="ksrd5ik16nsd" />}
              </span>
              <span className="min-w-0 flex-1" data-id="element-3509" data-mp="2wet5jimwophv">
                <span className="block text-[13px] font-medium text-deep" data-id="element-3510" data-mp="2wg49pjk9jz9i">
                  {tl(event.label)}
                </span>
                <span className="mt-[2px] block text-[11px] text-muted" data-id="element-3511" data-mp="31fqovyjnjpky">
                  {tl(event.when)}
                </span>
              </span>
            </li>)}
        </ul>
      </section>
    </div>;
}